import { api } from '@/modules/api';
import { AdvancedSearchParamsType, PPDBResponseDataType } from '@/types';
import { objectToURL } from '@/utils';
import { useQuery } from '@tanstack/react-query';

const requestApiGetConjunctions = async (
  query: AdvancedSearchParamsType,
  collection: string
) => {
  try {
    const response = await api.GET<null, PPDBResponseDataType>(
      process.env.REACT_APP_API_URL +
      `/cdm/${collection}` +
      objectToURL(query)
    );
    return {
      conjunctions: response.data.conjunctions,
      totalCount: response.data.totalCount,
      currentCount: response.data.currentCount,
      messageId: response.data.conjunctions[0]?.MESSAGE_ID,
    };
  } catch (err) {
    console.error(
      `Failed to fetch collection: '${collection}'`,
      err.response?.status,
      err.response?.data?.message
    );
    const emptyResult = {
      result: [],
    };
    throw err.response
      ? { ...err, message: err.response.data.message, data: emptyResult }
      : {
        message: new Error('Wrong Input Parameter.'),
        data: emptyResult,
      };
  }
};

const useQueryGetConjunctions = (query, queryKey, collection) => {
  const apiMethod = requestApiGetConjunctions;
  return useQuery({
    queryKey: [queryKey, query],
    queryFn: () => apiMethod(query, collection),
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
  });
};

export { requestApiGetConjunctions, useQueryGetConjunctions };
